import { Button } from '@/components/ui/button';
import { useAuth } from '@/components/auth/AuthProvider';
import TenantVirtuzoneSubmissions from './TenantVirtuzoneSubmissions';
import { LogOut } from 'lucide-react';
import { useLeadInsertNotifications } from '@/hooks/useLeadInsertNotifications';
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export default function TenantVirtuzoneAdmin() {
  const { signOut } = useAuth();
  useLeadInsertNotifications({ tenantId: undefined });

  useEffect(() => {
    // optional: test connection silently
    supabase.from('tenants').select('id').limit(1);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Top bar */}
      <div className="sticky top-0 z-40 flex h-14 items-center justify-between border-b border-gray-200 bg-white px-4">
        <div className="font-semibold text-gray-800">Tenant Dashboard - Virtuzone</div>
        <Button variant="ghost" size="sm" onClick={signOut}>
          <LogOut className="h-4 w-4 mr-1" /> Sign out
        </Button>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto p-4 sm:p-6">
        <TenantVirtuzoneSubmissions />
      </div>
    </div>
  );
}

